import { Component, DoCheck, Input } from '@angular/core';
import { FormControl, FormBuilder, Validators } from '@angular/forms';
import { each, find } from 'lodash';

import { DataLink } from '../../data-link/data-link';
import { RecordField } from '../../record/record';


const NUMBER_REGEX = /^[0-9]*$/;


@Component({
  selector: 't-data-link-form',
  templateUrl: './data-link-form.component.html',
})
export class DataLinkFormComponent implements DoCheck {

  @Input()
  link: DataLink

  fields: RecordField[]

  booleanOptions = [
    {
      value: 'Oui',
      text: 'Oui'
    },
    {
      value: '',
      text: 'Non'
    }
  ];

  constructor(private builder: FormBuilder) { }

  ngDoCheck() {
    this.buildForm();
  }


  buildForm() {
    let linkFields: RecordField[] = [];
    let nameField: RecordField;

    let linkModel = this.link.model;


    // Build link fields
    each(linkModel.fields, (fieldModel, fieldModelId) => {
      let field = find(this.link.fields, field => field.name === fieldModelId);

      // Create the field on the fly
      if (!field) {
        field = new RecordField();
        field.name = fieldModelId;
        field.model = fieldModel;
        field.selectDefaultValue();

        this.link.fields.push(field);
      }
      else {
        field.model = fieldModel;
      }

      // Name field needs validation
      if (field.model.input === 'text' && field.model.is_name) {
        let control = new FormControl(field.value, [
          Validators.required
        ]);

        control.valueChanges.subscribe((value) => {
          field.value = value;
        });

        field.control = control;

        nameField = field;
      }

      // Other fields
      else {
        linkFields.push(field);
      }
    });


    // Make sure the name control is the first one
    this.fields = [
      nameField,
      ...linkFields
    ];
  }
}